import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug="api"
const ContactMessageService = {
  getList: async () => {
    const response = await apiService.get(`/${slug}/usermessage`);
    console.log("🚀 ~ getList: ~ response:", response)
    return response.data;
  },
  detail: async (id) => {
    const response = await apiService.get(`/${slug}/usermessage/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(
      `/${slug}/usermessage/${id}`
    );
    return response.data;
},


}

export default ContactMessageService;
